<script setup lang="ts">
import { MoleculeReviewProps } from "./MoleculeReview.props"

defineProps<MoleculeReviewProps>()
</script>

<template>
  <div
    class="
      molecule-review-wrapper
      border-b-grey-100
      flex flex-col
      gap-4
      border-b
      pb-2
    "
  >
    <div v-if="rating" class="flex items-center gap-2">
      <UtilsStars :size="5" :stars="rating" />

      <p class="beaver-bold text-green-main">
        {{ rating }}
        {{ $t("productPage.moleculeReview.onFive") }}
      </p>
    </div>

    <div class="flex justify-between">
      <span v-if="date" class="mouse md:beaver-medium text-black-40">
        {{ date }}
      </span>
    </div>

    <p v-if="textReview" class="beaver">
      {{ textReview }}
    </p>

    <p v-if="reviewType" class="beaver text-green-main">
      <template v-if="reviewType == 'verified'">
        {{ $t("productPage.moleculeReview.verified") }}</template
      >
      <template v-else-if="reviewType == 'not_verified'">
        {{ $t("productPage.moleculeReview.not_verified") }}</template
      >
      <template v-else-if="reviewType == 'incentivized'">
        {{ $t("productPage.moleculeReview.incentivized") }}
      </template>
    </p>
  </div>
</template>
